import { request } from './config.js'

// 全局搜索=========================================
export const search = (params) => {
  return request.postjson({
    url: `/user/global/search`,
    data: JSON.stringify(params)
  })
}


// 当前用户的菜单=========================================
export const rolePermission = (params) => {
  return request.get({
    url: `/admin/rolePermission/menu`
  })
}


// 当前用户的文件夹路径=========================================
export const gettopFolder = () => {
  return request.get({
    url: `/user/folder/topFolder`,
  })
}
